import { changePassword, isPasswordValid } from './changePassword';
import React from 'react';
import { withRouter } from 'react-router-dom';
import ChangePasswordForm from './ChangePasswordForm';
import { NotificationManager } from 'react-notifications';

class ChangePasswordPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      credentials: {
        currentPassword: '',
        password: '',
        confirmPassword: '',
      },
      result: undefined,
      submitting: false,
    };
    this.navigateToDashboard = this.navigateToDashboard.bind(this);
  }

  validateForm() {
    if (!isPasswordValid(this.state.credentials.password)) {
      NotificationManager.error('Password must be at least 8 characters');
      return false;
    }
    if (
      this.state.credentials.password !== this.state.credentials.confirmPassword
    ) {
      NotificationManager.error('Passwords do not match!');
      return false;
    }
    return true;
  }

  handleCredentialsChange = (newCredentials) => {
    this.setState({
      credentials: { ...newCredentials },
    });
  };

  onSubmit = (ok) => {
    if (ok && this.validateForm()) {
      this.setState({ submitting: true });
      var data = {
        currentPassword: this.state.credentials.currentPassword,
        newPassword: this.state.credentials.password,
      };

      changePassword(data)
        .then((response) => {
          this.setState({
            result: {
              status: 'success',
              message: 'Password change completed.',
            },
          });
        })
        .catch((e) => {
          return Promise.reject(e);
        })
        .finally(() => this.setState({ submitting: false }));
    }
  };

  navigateToDashboard() {
    this.props.history.push('/dashboard');
  }

  render() {
    return (
      <ChangePasswordForm
        passwordCredentials={this.state.credentials}
        onSubmit={this.onSubmit}
        onCancel={this.navigateToDashboard}
        onPasswordCredentialsUpdated={this.handleCredentialsChange}
        result={this.state.result}
        submitting={this.state.submitting}
      />
    );
  }
}

const ChangePassword = withRouter(ChangePasswordPage);
export { ChangePassword };
